import { Container, Navbar, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/THS-logo.png";
import avatar from "../../assets/images/User.png";
import { SlUser } from "react-icons/sl";
import { GoChevronDown } from "react-icons/go";
import { RiKeyFill, RiLogoutCircleLine } from "react-icons/ri";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import DeleteModal from "../Common/DeleteModal/DeleteModal";
import { useState } from "react";
import moment from "moment";
const Header = () => {

  let companyId = localStorage.getItem("company_uuid");
  const [modalMessage, setModalMessage] = useState<string | undefined>("");
  const [modalBtnLabel, setModalBtnLabel] = useState<string | undefined>(undefined);
  const [modalBtnClass, setModalBtnClass] = useState<string | undefined>(undefined);
  const [modalApiMethod, setModalAPIMethod] = useState("DELETE");
  const [modalApiBody, setModalAPIBody] = useState<{ status: string } | null>(null);
  const [showDelete, setShowDelete] = useState(false);
  const [action, setAction] = useState("");

  // const ReactivateAccount = () => {
  //   return WebService.apiRequest({
  //     method: "PUT",
  //     action: `company/${companyId}/reactivate/${cancellationToken}`,
  //   })
  //     .then((res: any) => {
  //       toast.success(res?.message);

  //       localStorage.setItem("is_canceled_schedule", "0");
  //       localStorage.removeItem("cancel_schedule_at");
  //     })
  //     .catch((error: any) => {
  //       if (error?.response?.data?.message) {
  //         toast.error(error?.response?.data?.message);
  //       }
  //       return error;
  //     });
  // };

  const handleDelete = (flag: boolean) => {
    if (flag) getCompanyDetails();
    setShowDelete(false);

  };

  const getCompanyDetails = () => {
    return WebService.apiRequest({
      method: "GET",
      action: `company/${companyId}`,
      body: {},
    })
      .then((res: any) => {
        if (res?.info?.canceled_at !== null) {
          let cancel_date = '';
          if (res?.canceled_at) {
            cancel_date = moment(res?.info?.canceled_at).format("MM/DD/YYYY");
          }

          localStorage.setItem("is_canceled_schedule", "1");
          localStorage.setItem("cancel_schedule_at", cancel_date);

          setAction(
            `company/${companyId}/reactivate/${res?.info?.reactivation_token}`,
          );

          setModalAPIMethod("PUT")
          setModalMessage("Are you sure you want to re-activate this account ?")
          setModalAPIBody(null)
          setShowDelete(true);
          setModalBtnLabel("Re-Activate Account")
          setModalBtnClass("btn-success")


        } else {
          res.info.canceled_at = ""
          localStorage.setItem("is_canceled_schedule", "0");
          localStorage.removeItem("cancel_schedule_at");
          window.location.reload();
        }

      })
      .catch((error: any) => {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      });
  };
  let header_logo = localStorage.getItem("header_logo");
  console.log("header_logo", header_logo);

  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg">
            <Navbar.Brand className="me-1">
              <img src={header_logo ?? Logo} height={50} alt="" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            {
              (localStorage.getItem("role") !== "admin_user" && localStorage.getItem("is_canceled_schedule") === "1") && <div className="w-75 text-center">
                <div className="alert alert-danger font-22" role="alert" style={{ margin: "6px", padding: "6px", color: "#fff", backgroundColor: "#dc3545", borderColor: "#dc3545" }}>
                  This account is scheduled to be cancelled on {localStorage.getItem("cancel_schedule_at")}. <a href="javascript:void(0)"
                    onClick={() => {
                      getCompanyDetails();
                    }}
                    className="click-here">Click here</a> to stay active.
                </div>
              </div>
            }

            <div className="d-flex align-items-center ms-auto gap-3">
              <Dropdown className="profile-dd">
                <Dropdown.Toggle>
                  <div className="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src={avatar}
                        width={35}
                        height={35}
                        className=" rounded-circle object-fit-cover"
                        alt=""
                      />
                    </div>
                    <div style={{ lineHeight: '17px' }}>
                      <p className="font-14 mb-0 text-dark font-medium">
                        {localStorage.getItem("full_name")}
                      </p>
                      <p className="font-12 mb-0 text-secondary">
                        {localStorage.getItem("user_email_id")}
                      </p>
                    </div>
                  </div>
                  <GoChevronDown size={16} className="icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  {/* <Link to="" className=" dropdown-item"> <SlUser size={14} className="me-2" /> My Profile</Link> */}
                  <Link to="/change-password" className=" dropdown-item" onClick={() => {
                  }}>

                    <RiKeyFill
                      size={14}
                      className="me-2"

                    />{" "}
                    Change Password
                  </Link>

                  <Link to="/login" className=" dropdown-item" onClick={() => {
                    localStorage.clear()
                  }}>

                    <RiLogoutCircleLine
                      size={14}
                      className="me-2"

                    />{" "}
                    Logout
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar>
        </Container>
      </header>
      <DeleteModal
        message={modalMessage}
        body={modalApiBody}
        api_method={modalApiMethod}
        btn_class={modalBtnClass}
        btn_label={modalBtnLabel}
        action={action}
        onDelete={(flag: boolean) => {
          handleDelete(flag);
        }}
        show={showDelete}

      />
    </>
  );
};
export default Header;
